import client from './client';
import { PackagingItem, PackagingType } from '../types/packaging';

function asArray<T>(raw: any, key: string): T[] {
  return (
    (Array.isArray(raw?.[key]) && raw[key]) ||
    (Array.isArray(raw?.data) && raw.data) ||
    (Array.isArray(raw) && raw) ||
    []
  );
}

export async function getPackaging(): Promise<PackagingItem[]> {
  const res = await client.get('/api/admin/packaging');
  return asArray<PackagingItem>(res.data, 'packaging');
}

export async function createPackagingItem(input: {
  item_name: string;
  item_type: PackagingType | null;
  quantity: number;
  unit_cost: number;
  reorder_level: number;
  notes: string;
}): Promise<void> {
  await client.post('/api/admin/packaging', input);
}

// Name, type, reorder level and notes only. Stock and cost move through
// restock, which is what stamps last_restocked_at.
export async function updatePackagingItem(
  id: string,
  patch: {
    item_name?: string;
    item_type?: PackagingType | null;
    reorder_level?: number;
    notes?: string;
  }
): Promise<void> {
  await client.put(`/api/admin/packaging/${id}`, patch);
}

// Removes the item from the standard set. Every parcel consumes one of each row,
// so this also removes it from all future parcels' cost and deduction. Past
// orders are unaffected — their packaging was priced at shipment time.
// `warning` is returned when the item still held stock.
export async function deletePackagingItem(
  id: string
): Promise<{ warning?: string }> {
  const res = await client.delete(`/api/admin/packaging/${id}`);
  return { warning: res.data?.warning };
}

// Adds units and moves unit_cost to what this batch cost. Omit unit_cost to
// restock at the price already on record.
export async function restockPackaging(
  id: string,
  quantity: number,
  unitCost?: number
): Promise<void> {
  await client.post(`/api/admin/packaging/${id}/restock`, {
    quantity,
    ...(unitCost !== undefined ? { unit_cost: unitCost } : {}),
  });
}
